// Web shim for @react-native-documents/picker using HTML file input
export const pick = (options) =>
  new Promise((resolve, reject) => {
    const input = document.createElement('input');
    input.type = 'file';
    if (options?.type && options.type !== '*/*') {
      input.accept = Array.isArray(options.type) ? options.type.join(',') : options.type;
    }
    input.multiple = options?.allowMultiSelection || false;
    input.onchange = (e) => {
      const files = Array.from(e.target.files || []);
      if (!files.length) {
        reject({ code: 'DOCUMENT_PICKER_CANCELED' });
        return;
      }
      resolve(
        files.map((f) => ({
          uri: URL.createObjectURL(f),
          name: f.name,
          size: f.size,
          type: f.type,
          fileCopyUri: null,
        }))
      );
    };
    input.oncancel = () => reject({ code: 'DOCUMENT_PICKER_CANCELED' });
    input.click();
  });

export const pickSingle = (options) =>
  pick({ ...options, allowMultiSelection: false }).then((results) => results[0]);

export const isCancel = (err) => err && err.code === 'DOCUMENT_PICKER_CANCELED';
export const isInProgress = () => false;

export const types = {
  allFiles: '*/*',
  images: 'image/*',
  plainText: 'text/plain',
  audio: 'audio/*',
  pdf: 'application/pdf',
  zip: 'application/zip',
  csv: 'text/csv',
  doc: 'application/msword',
  docx: 'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
  ppt: 'application/vnd.ms-powerpoint',
  pptx: 'application/vnd.openxmlformats-officedocument.presentationml.presentation',
  xls: 'application/vnd.ms-excel',
  xlsx: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
};
